import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'jquery-ui/ui/effects/effect-slide';
import 'jquery-ui/ui/effects/effect-fade';
import { Box, Button, Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import './stripo.css';
import CustomModal from './CustomModalStripo';
import axios from 'axios';

const Stripo = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [inputName, setInputName] = useState('');
  const [inputText, setInputText] = useState('');

  useEffect(() => {
    function request(method, url, data, callback) {
      const req = new XMLHttpRequest();
      req.onreadystatechange = function () {
        if (req.readyState === 4 && req.status === 200) {
          callback(req.responseText);
        } else if (req.readyState === 4 && req.status !== 200) {
          console.error(
            'Cannot complete request. Please check you entered valid PLUGIN_ID and SECRET_KEY values',
          );
        }
      };
      req.open(method, url, true);
      if (method !== 'GET') {
        req.setRequestHeader('content-type', 'application/json');
      }
      req.send(data);
    }

    function loadDemoTemplate(callback) {
      const templateFromLocalStorage =
        localStorage.getItem('emailTemplateHtml');
      if (templateFromLocalStorage) {
        request(
          'GET',
          'https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Trigger%20newsletter%20mockup/Trigger%20newsletter%20mockup.css',
          null,
          function (css) {
            callback({ html: templateFromLocalStorage, css });
          },
        );
      } else {
        request(
          'GET',
          'https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Trigger%20newsletter%20mockup/Trigger%20newsletter%20mockup.html',
          null,
          function (html) {
            request(
              'GET',
              'https://raw.githubusercontent.com/ardas/stripo-plugin/master/Public-Templates/Basic-Templates/Trigger%20newsletter%20mockup/Trigger%20newsletter%20mockup.css',
              null,
              function (css) {
                callback({ html, css });
              },
            );
          },
        );
      }
    }

    function initPlugin(template) {
      const apiRequestData = {
        emailId: 123,
      };
      const script = document.createElement('script');
      script.id = 'stripoScript';
      script.type = 'text/javascript';
      script.src = 'https://plugins.stripo.email/static/latest/stripo.js';
      script.onload = function () {
        window.Stripo.init({
          settingsId: 'stripoSettingsContainer',
          previewId: 'stripoPreviewContainer',
          codeEditorButtonId: 'codeEditor',
          undoButtonId: 'undoButton',
          redoButtonId: 'redoButton',
          locale: 'en',
          html: template.html,
          css: template.css,
          notifications: {
            info: notifications.info.bind(notifications),
            error: notifications.error.bind(notifications),
            warn: notifications.warn.bind(notifications),
            loader: notifications.loader.bind(notifications),
            hide: notifications.hide.bind(notifications),
            success: notifications.success.bind(notifications),
          },
          apiRequestData: apiRequestData,
          userFullName: 'Plugin Demo User',
          versionHistory: {
            changeHistoryLinkId: 'changeHistoryLink',
            onInitialized: function (lastChangeIndoText) {
              $('#changeHistoryContainer').show();
            },
          },
          getAuthToken: function (callback) {
            request(
              'POST',
              'https://plugins.stripo.email/api/v1/auth',
              JSON.stringify({
                pluginId: '5d3a44956b5f4f4e8d2bae2f81cda08e',
                secretKey: '384b19744d1c4dfe83cb10cecd7540ea',
              }),
              function (data) {
                callback(JSON.parse(data).token);
              },
            );
          },
        });
      };
      document.body.appendChild(script);
    }

    loadDemoTemplate(initPlugin);

    const notifications = {
      autoCloseTimeout: 10000,
      container: '.notification-zone',
      error: function (text, id, params) {
        this.showNotification(
          this.getErrorNotification.bind(this),
          text,
          id,
          params,
        );
      },
      warn: function (text, id, params) {
        this.showNotification(
          this.getWarningNotification.bind(this),
          text,
          id,
          params,
        );
      },
      info: function (text, id, params) {
        this.showNotification(
          this.getInfoNotification.bind(this),
          text,
          id,
          params,
        );
      },
      success: function (text, id, params) {
        this.showNotification(
          this.getSuccessNotification.bind(this),
          text,
          id,
          params,
        );
      },
      loader: function (text, id, params) {
        this.showNotification(
          this.getLoaderNotification.bind(this),
          text,
          id,
          params,
        );
      },
      hide: function (id) {
        const toast = $('#' + id, this.container);
        toast.effect('fade', 600, function () {
          toast.remove();
        });
      },
      showNotification: function (notificationGetter, text, id, params) {
        params = Object.assign(
          { autoClose: true, closeable: true },
          params || {},
        );
        if (!id || !$('#' + id).length) {
          const toast = notificationGetter(text, id, !params.closeable);
          $(this.container).append(toast);
          toast.effect('slide', { direction: 'down' }, 300);
          if (params.autoClose) {
            setTimeout(function () {
              toast.effect('fade', 600, function () {
                toast.remove();
              });
            }, this.autoCloseTimeout);
          }
        }
      },
      getErrorNotification: function (text, id, nonclosable) {
        return this.getNotificationTemplate(
          'alert-danger',
          text,
          id,
          nonclosable,
        );
      },
      getWarningNotification: function (text, id, nonclosable) {
        return this.getNotificationTemplate(
          'alert-warning',
          text,
          id,
          nonclosable,
        );
      },
      getInfoNotification: function (text, id, nonclosable) {
        return this.getNotificationTemplate(
          'alert-info',
          text,
          id,
          nonclosable,
        );
      },
      getSuccessNotification: function (text, id, nonclosable) {
        return this.getNotificationTemplate(
          'alert-success',
          text,
          id,
          nonclosable,
        );
      },
      getLoaderNotification: function (text, id) {
        const notification = $(
          '<div class="alert alert-info" role="alert"><div style="width:auto; margin-right: 15px; float: left !important;"><div style="width:20px;height:20px;border-radius:50%;box-shadow:1px 1px 0px #31708f; animation:cssload-spin 690ms infinite linear"></div></div>' +
            text +
            '</div>',
        );
        id && notification.attr('id', id);
        return notification;
      },
      getNotificationTemplate: function (classes, text, id, nonclosable) {
        const notification = $(
          '<div class="alert alert-dismissible ' +
            classes +
            (nonclosable ? ' nonclosable' : '') +
            '" role="alert">' +
            (nonclosable
              ? ''
              : '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>') +
            text +
            '</div>',
        );
        id && notification.attr('id', id);
        return notification;
      },
    };

    document
      .querySelector('#saveButton')
      .addEventListener('click', function () {
        setIsOpen(true); // Open the modal when save button is clicked
      });

    document
      .querySelector('#exportButton')
      .addEventListener('click', function () {
        const message =
          'The operation is successful. You can find the code in the console of your browser. This is an example of the compileEmail() function in action.';
        window.StripoApi.compileEmail(function (
          error,
          html,
          ampHtml,
          ampErrors,
        ) {
          console.log(
            '%cThis method returns compiled and compressed HTML code that is ready to be sent out to clients.',
            'background-color: #d8f0d8',
          );
          console.log(html);
        });
        notifications.success(message);
      });

    document
      .querySelector('#startSendingEmailsButton')
      .addEventListener('click', function () {
        history.push('/admin/book-meeting');
      });
  }, []);

  const handleModalSave = async () => {
    try {
      const template = await new Promise((resolve, reject) => {
        window.StripoApi.getTemplate((html, css) => {
          resolve({ html, css });
        });
      });

      const response = await axios.post(
        'https://bounce.mailamp.in/campaign/save',
        {
          name: inputName,
          text: inputText,
          htmlString: template.html,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        console.log('🚀 ~ res:', response);
        toast.success('Template saved successfully!');
        setIsOpen(false); // Close the modal only after successful save
      } else {
        throw new Error('Unexpected response status');
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      toast.error('Failed to save the template. Please try again.');
      // Keep the modal open so the user can retry
    }

    console.log('Name:', inputName);
    console.log('Text:', inputText);
    setInputName('');
    setInputText('');
  };

  const onClose = () => {
    setInputName('');
    setInputText('');
    setIsOpen(false);
  };

  return (
    <div>
      <div style={{ height: '60px' }}></div>
      <div id="externalSystemContainer">
        <div>
          <button id="undoButton" className="control-button">
            Undo
          </button>
          <button id="redoButton" className="control-button">
            Redo
          </button>
          <button id="codeEditor" className="control-button">
            Code editor
          </button>
          <span id="changeHistoryContainer" style={{ display: 'none' }}>
            Last change: <a id="changeHistoryLink"></a>
          </span>
        </div>
        <div>
          <button id="startSendingEmailsButton" className="control-button">
            Start Sending Emails
          </button>
          <button id="saveButton" className="control-button">
            Save
          </button>
          <button id="exportButton" className="control-button">
            Export
          </button>
        </div>
      </div>
      <div className="notification-zone"></div>
      <div>
        <div id="stripoSettingsContainer">Loading...</div>
        <div id="stripoPreviewContainer"></div>
      </div>

      <CustomModal
        isOpen={isOpen}
        onClose={onClose}
        inputName={inputName}
        setInputName={setInputName}
        inputText={inputText}
        setInputText={setInputText}
        handleModalSave={handleModalSave}
      />
    </div>
  );
};

export default Stripo;
